import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import swal from "sweetalert";

import {
  editLeaseRegisterApiHandler,
  getCompaniesOption,
  getLeaseProjectApiHandler,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import Loader2 from "../../elements/Loader2";
import commoncss from "../../css/common.module.css";
import createRegCss from "../../css/createregister.module.css";
import buttoncss from "../../css/button.module.css";
import InputGroup from "../../elements/InputGroup";
import Dropdown from "../../elements/Dropdown";
import Breadcrumb from "../../components/Breadcrumb";
import { useParams } from "react-router-dom";
import accountant from "../../../../src/assets/signIn.svg";
import ApproverLeaseModal from "../leases/ApproverLeaseModal";

import { useHistory } from "react-router";

const EditLoanRegister = () => {
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("user"));
  const { leaseId } = useParams();

  console.log("Lease ID:", leaseId);
  const [loader, setLoader] = useState(false);
  const [allCompany, setAllCompany] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [company, setCompany] = useState(null);
  const [selCompanyId, setSelCompanyId] = useState(null);
  const [regName, setRegName] = useState(null);
  const [approverId, setApproverId] = useState(null);
  const [approverLeaseModal, setApproverLeaseModal] = useState(false);
  const [isApprovalPending, setIsApprovalPending] = useState(false);

  useEffect(() => {
    GetCompany();
    getLeaseDetails();
  }, []);

  const GetCompany = async () => {
    const res = await getCompaniesOption();
    if (res.status === 200) {
      setAllCompany(res.data.getCompany);
    }
  };

  useEffect(() => {
    const options = allCompany.map((c) => ({
      label: c.company_name,
      value: c._id,
    }));
    setCompanyOptions(options);
  }, [allCompany]);

  useEffect(() => {
    console.log("companyOptions, selCompanyId", companyOptions, selCompanyId);

    if (companyOptions && selCompanyId) {
      const selectedCompany = companyOptions.find(
        (item) => item.value === selCompanyId
      );
      setCompany(selectedCompany);
    }
  }, [companyOptions, selCompanyId]);

  const getLeaseDetails = () => {
    const params = {
      id: leaseId,
    };
    getLeaseProjectApiHandler(params)
      .then((response) => {
        console.log("response", response?.data?.project);

        if (response?.data?.project) {
          const projectObj = response?.data?.project;
          setRegName(projectObj.name);
          setSelCompanyId(projectObj.companyID);
          setIsApprovalPending(projectObj.approvalStatus?.includes("pending"));
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to get lease details",
          "error"
        );
      });
  };

  const updateLeaseRegister = () => {
    const payload = {
      name: regName,
      companyID: company.value,
    };
    console.log(payload);
    editLeaseRegisterApiHandler({ id: leaseId }, payload)
      .then((response) => {
        console.log(
          "Update Lease Register resp",
          response,
          response?.data?.project?._id
        );
        if (response?.data?.project?._id) {
          setLoader(true);
          window.location.href = `${process.env.REACT_APP_LEASE_FRONTEND_URL}overview/${response?.data?.project?._id}`;
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable Update Lease Register",
          "error"
        );
      });
  };

  const sendForApproval = (approverID) => {
    const payload = {
      name: regName,
      companyID: company.value,
      approvalStatus: "pending approval",
      approverID: approverID,
    };
    editLeaseRegisterApiHandler({ id: leaseId }, payload)
      .then((response) => {
        console.log("response", response);

        if (response?.data?.project) {
          swal(
            "Success",
            "Approval sent for creation of lease register",
            "success"
          );
          setApproverLeaseModal(false);
        }
        history.pushState();
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable send for approval",
          "error"
        );
      });
  };

  const breadcrumbItems = [
    {
      label: "Home",
      link: `/dashboard`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Edit Register",
      link: `/dashboard`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: `Lease`, link: "", className: "headerLable" },
  ];

  return (
    <>
      <div className="conatiner">
        {loader && <Loader2 />}

        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className={createRegCss.imgContainer}
        >
          <img
            src={accountant}
            alt="accountant working"
            style={{
              height: "93.7vh",
              "place-self": "center",
            }}
          />
        </motion.div>
        <motion.div
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className={createRegCss.formContainer}
        >
          <div className={commoncss.dFlexJustifysb}>
            <Breadcrumb
              style="margin-right:auto"
              items={breadcrumbItems}
              headerActions={<></>}
            />
          </div>
          <motion.div
            initial={{ x: 400, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.7, ease: "easeInOut" }}
          >
            <div className={createRegCss.alignForm}>
              <div className={createRegCss.container2}>
                <div className={`${commoncss.dFlex} mb-3`}>
                  <div
                    className={commoncss.dFlexClm}
                    style={{ alignItems: "center" }}
                  >
                    <span className={createRegCss.heading1}>
                      Edit Lease Register
                    </span>
                    <span className={createRegCss.label1}>
                      Edit register name and it’s company
                    </span>
                  </div>
                </div>
                <div className={`${createRegCss.container3} mt-3 mb-1`}>
                  <InputGroup
                    label="Name of Lease Register"
                    inputs={[
                      <>
                        <input
                          name="invreg_name"
                          placeholder="Lease register"
                          type="text"
                          value={regName}
                          onChange={(e) => setRegName(e.target.value)}
                          disabled={isApprovalPending}
                        />
                      </>,
                    ]}
                  />
                  <InputGroup
                    label="Company name"
                    class_="mt-2"
                    inputs={[
                      <>
                        {isApprovalPending ? (
                          <input
                            name="selCom"
                            placeholder="Select Company"
                            type="text"
                            value={company.label}
                            disabled={isApprovalPending}
                          />
                        ) : (
                          companyOptions.length > 0 && (
                            <Dropdown
                              //   label="Select Company"
                              selected={company}
                              options={companyOptions}
                              onSelect={(opt) =>
                                !isApprovalPending && setCompany(opt)
                              }
                              placeHolder={"Select Company"}
                            />
                          )
                        )}
                      </>,
                    ]}
                  />
                  <div
                    className="mt-4"
                    style={{ width: "70%", placeSelf: "center" }}
                  >
                    {user?.isAdmin === "Yes" && (
                      <button
                        type="submit"
                        className={`${buttoncss.primary} ${
                          !company?.value || !regName
                            ? buttoncss.disabledBtn
                            : ""
                        }`}
                        style={{
                          padding: "7px",
                          width: "100%",
                          "border-radius": "12px",
                        }}
                        disabled={!company?.value || !regName}
                        onClick={() => {
                          updateLeaseRegister();
                        }}
                      >
                        Save Changes
                      </button>
                    )}
                    {user?.responsibilities === "preparer" && (
                      <button
                        type="submit"
                        className={`${buttoncss.primary} ${
                          !company?.value || !regName || isApprovalPending
                            ? buttoncss.disabledBtn
                            : ""
                        }`}
                        style={{
                          padding: "7px",
                          width: "100%",
                          "border-radius": "12px",
                        }}
                        onClick={() => {
                          company?.value &&
                            regName &&
                            setApproverLeaseModal(true);
                        }}
                        disabled={
                          !company?.value || !regName || isApprovalPending
                        }
                      >
                        Send changes for approval
                      </button>
                    )}
                  </div>
                  {approverLeaseModal && (
                    <ApproverLeaseModal
                      setApproverLeaseModal={setApproverLeaseModal}
                      companyId={company?.value}
                      setApproverId={setApproverId}
                      sendForApproval={sendForApproval}
                    />
                  )}
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </>
  );
};

export default EditLoanRegister;
